module.exports = __webpack_public_path__ + "static/media/ico_simulation_eye_dc.5d9ffd63.png";